
const { LOADER } = require("../reduxConsts").ACTION_TYPES



export const showLoader = () => ({ type: LOADER.SHOW_LOADER })
export const hideLoader = () => ({ type: LOADER.HIDE_LOADER })
